import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

export default function Footer() {
  return (
    <div className="Footer">
      <br />
      <p>
        <a
          href="https://github.com/lovisasars/weather-app-react"
          target="_blank"
        >
          Open-source code
        </a>{" "}
        by Lovisa Sars
      </p>
    </div>
  );
}
